import React from 'react'

export function AnalysisSkeleton() {
  return (
    <div className="flex flex-col items-center justify-center py-28 animate-[an-fadeIn_0.3s_ease]">
      <svg className="animate-spin text-an-accent mb-5" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <circle cx="16" cy="16" r="13" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" opacity="0.15" />
        <path d="M29 16a13 13 0 00-13-13" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
      </svg>
      <span className="text-[14px] text-an-ink-2 font-semibold tracking-[-0.01em]">Loading analysis…</span>
      <span className="text-[12px] text-an-ink-3 mt-1">Fetching legislative impact data</span>
    </div>
  )
}
